const WORDS = ["Casamentos", "Corridas", "Formaturas", "Congressos", "Aniversários", "Torneios", "Convenções", "Festas de 15", "Lançamentos", "Ensaios"];

export const Marquee = () => (
  <section className="relative overflow-hidden border-b border-white/10 bg-violet-deep/40 py-8" data-testid="editorial-marquee" aria-label="Tipos de evento">
    <div className="marquee-track flex">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`px-8 font-display text-5xl font-extrabold tracking-tight sm:text-7xl ${i % 2 ? "text-outline" : "text-foreground"}`}>{w}</span>
              <svg viewBox="0 0 24 24" className="h-7 w-7 shrink-0 text-flash" aria-hidden><path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
